import { IonToolbar, IonTitle} from '@ionic/react';
import MySocials from "./MySocials";

      /* */

function MyToolbar(){
    return (
      <IonToolbar mode="ios" className="ion-toolbar" color="#ffe5b4">
        <IonTitle
          className="ion-title-bar title-heading ion-text-left ion-padding-end"
          mode="ios"
          size="large"
        >
          Cameron Lowry
        </IonTitle>
        <MySocials />
      </IonToolbar>
    );
}

export default MyToolbar;